export enum MatchSection {
  Pre = 'PRE',
  Live = 'LIVE',
  Post = 'POST',
}
